module.exports = __webpack_public_path__ + "3f93e1f724536e3d921e96d34fab6e84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/accommodation.svg
// module id = 1529
// module chunks = 1 6